export default "__VITE_ASSET__DFzQld37__"